module.exports = __webpack_public_path__ + "img/Speaker=Leo Zhou.4f0a79fd.png";